import { Typography } from '@platform/elements';

import { TrustpilotSnippet } from '@website/lib-shared/src/components/blocks/TrustpilotSnippet/TrustpilotSnippet.js';
import type { LinkReference } from '@website/lib-shared/src/models/linkReference.js';
import { EmptyStateErrorMessage } from '@website/lib-shared/src/components/moduleWrapper/components/errors/EmptyStateErrorMessage.js';
import { ButtonLinkComp } from '@website/lib-shared/src/components/blocks/ButtonLink/ButtonLinkComp.js';
import { LessEquityThanIncidentalCostsHintMessage } from '@website/lib-shared/src/components/moduleWrapper/components/hints/LessEquityIncidentialCost/LessEquityIncidentialCost.js';
import { LinkComp } from '@website/lib-shared/src/components/blocks/Link/LinkComp.js';
import { InsufficientLoanAmountErrorMessageComp } from '@website/lib-shared/src/components/moduleWrapper/components/errors/InsufficientLoanAmountErrorMessageComp.js';

import type { RepaymentCalculatorPresetProps } from '../types/RepaymentCalculatorPresetProps.js';

export const createPresetWebsiteRepaymentCalculator = ({
  ctaLink,
  ctaLabel,
  ctaDescription,
  insufficientLoanAmountLink,
}: {
  ctaLink?: LinkReference;
  ctaLabel?: string;
  ctaDescription?: string;
  insufficientLoanAmountLink?: LinkReference;
}): RepaymentCalculatorPresetProps => ({
  content: {
    ...(ctaLink && {
      emptyResultErrorContent: <EmptyStateErrorMessage ctaLink={ctaLink} />,
      resultAction: <ButtonLinkComp linkReference={ctaLink}>{ctaLabel}</ButtonLinkComp>,
      lessEquityThanIncidentalCosts: ({ action }: { action: () => void }) => (
        <LessEquityThanIncidentalCostsHintMessage Link={LinkComp} action={action} ctaLink={ctaLink} />
      ),
    }),
    followUp: (
      <>
        {ctaDescription && <Typography variant="strong">{ctaDescription}</Typography>}
        <TrustpilotSnippet locale="de-DE" templateId="5419b637fa0340045cd0c936" theme="light" height="20px" width="100%" />
        {ctaLink && <ButtonLinkComp linkReference={ctaLink}>{ctaLabel}</ButtonLinkComp>}
      </>
    ),
  },
  formErrors: {
    insufficientLoanAmount: () => <InsufficientLoanAmountErrorMessageComp link={insufficientLoanAmountLink} />,
  },
});
